import React, { useEffect, useState } from "react";
import {
    Button,
    Col,
    Form,
    Row,
    Input,
    FormGroup,
    Label,
    Table,
} from "reactstrap";
import swal from 'sweetalert2';
import axios from "axios";
import { baseurl } from "../../../baseurl";
import { GetIp } from "../../Forms/ShortCutComponents/Get_ip.jsx";
import ResponseLoader from "../../Forms/ShortCutComponents/ResponseLoader";

export default function StaffRoles(props) {
    var username = localStorage.getItem("username");
    var token = localStorage.getItem("token");
    var companyId = localStorage.getItem("companyId");

    const [loadingResponse, setLoadingResponse] = useState(false);
    const [data, setData] = useState({
        desc1: "",
        showModalAddNew: true,
    });
    const [StaffRoles, setStaffRoles] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [editData, setEditData] = useState({ desc1: "" });

    const cleanInput = () => {
        setData({ desc1: "" });
    }

    const getData = () => {
        axios
            .post(
                `${baseurl}/pointOfSale/getStaffRoles`,
                { companyId, username },
                { headers: { authorization: token } }
            )
            .then((res) => {
                setStaffRoles(res.data.data);
                console.log(res.data.data);
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        getData();
    }, []);

    const inputEvent = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    const handleSubmitAddItem = async (event) => {
        event.preventDefault();
        setLoadingResponse(true);
        let { userIp, userCountry } = await GetIp();

        axios
            .post(
                `${baseurl}/pointOfSale/AddStaffRoles`,
                {
                    companyId,
                    desc1: data.desc1,
                    username,
                    userIp,
                    userCountry,
                },
                { headers: { authorization: token } }
            )
            .then((response) => {
                setLoadingResponse(false);
                if (response.data.duplicate) {
                    swal.fire({
                        title: "Duplicate Code is not Allowed",
                        text: "Duplicate Entry",
                        icon: "error",
                    });
                } else {
                    swal.fire({
                        title: "Saved Successfully!",
                        text: "StaffRoles Added",
                        icon: "success",
                    }).then(() => {
                        setStaffRoles([
                            ...StaffRoles,
                            { id: response.data.id, desc1: data.desc1 },
                        ]);
                        setData({ desc1: "" });
                    });
                }
            })
            .catch(() => {
                setLoadingResponse(false);
                swal.fire({
                    title: "Error",
                    text: "Something went wrong. Try again.",
                    icon: "error",
                });
            });
    };

    const handleEdit = (StaffRoles) => {
        console.log('StaffRoles', StaffRoles)
        setEditingId(StaffRoles.waiter_type_id);
        setEditData({ desc1: StaffRoles.desc1 });
    };

    const handleUpdate = () => {
        axios
            .post(
                `${baseurl}/pointOfSale/updateStaffRoles`,
                {
                    companyId,
                    username,
                    Id: editingId,
                    desc1: editData.desc1,
                },
                { headers: { authorization: token } }
            )
            .then(() => {
                setStaffRoles(
                    StaffRoles.map((item) =>
                        item.id === editingId ? { ...item, ...editData } : item
                    )
                );
                console.log('editingId', editingId)
                setEditingId(null);
                getData();

                swal.fire({
                    title: "Updated!",
                    text: "StaffRoles Updated Successfully",
                    icon: "success",
                });
            })
            .catch(() => {
                swal.fire({
                    title: "Error",
                    text: "Something went wrong, try again.",
                    icon: "error",
                });
            });
    };
    const handleDelete = (waiter_type_id) => {
        swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                axios
                    .post(
                        `${baseurl}/pointOfSale/deleteStaffRoles`,
                        { companyId, username, Id: waiter_type_id },
                        { headers: { authorization: token } }
                    )
                    .then(() => {
                        setStaffRoles(
                            StaffRoles.filter(
                                (item) => item.waiter_type_id !== waiter_type_id
                            )
                        );
                        swal.fire("Deleted!", "StaffRoles has been deleted.", "success");
                    })
                    .catch(() => {
                        swal.fire("Error!", "Something went wrong. Try again.", "error");
                    });
            }
        });
    };

    return (
        <>
            {loadingResponse ? (
                <ResponseLoader />
            ) : (
                <div className="container-fluid bg-white">
                    <div className="row d-flex justify-content-between">
                        <div className="col-md-8 h3 p-3">Staff Roles</div>
                        <div className="mt-3 mr-4"></div>
                    </div>
                    <Form name="simpleForm" onSubmit={handleSubmitAddItem}>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <Label style={{ fontWeight: "bold" }}>
                                    Staff Roles Description:
                                </Label>
                                <Input
                                    value={data.desc1}
                                    onChange={inputEvent}
                                    required
                                    name="desc1"
                                />
                            </div>
                        </div>
                        <FormGroup>
                            <Button type="submit" className="mr-2 invoiceSubmitButton">
                                Save
                            </Button>
                            <Button onClick={cleanInput} size="sm">
                                Cancel
                            </Button>
                        </FormGroup>
                    </Form>

                    <div translate="no" className="">

                        <Table bordered striped className="mt-4">
                            <thead>
                                <tr>
                                    <th>Staff Roles Description</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {StaffRoles.length > 0 ? (
                                    StaffRoles.map((StaffRoles) => (
                                        <tr key={StaffRoles.waiter_type_id}>
                                            <td>
                                                {editingId === StaffRoles.waiter_type_id ? (
                                                    <Input
                                                        value={editData.desc1}
                                                        onChange={(e) =>
                                                            setEditData({
                                                                ...editData,
                                                                desc1: e.target.value,
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    StaffRoles.desc1
                                                )}
                                            </td>

                                            <td>
                                                <Button
                                                    type="button"
                                                    className="m-1"
                                                    size="sm"
                                                    color="danger"
                                                    onClick={() =>
                                                        handleDelete(StaffRoles.waiter_type_id)
                                                    }
                                                >
                                                    Delete
                                                </Button>

                                                {editingId === StaffRoles.waiter_type_id ? (
                                                    <Button
                                                        color="success"
                                                        size="sm"
                                                        onClick={handleUpdate}
                                                    >
                                                        Save
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        onClick={() => handleEdit(StaffRoles)}
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center">
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
            )}
        </>
    );
}
